<div class="copy-dialog">
  <p>
    Copy signature roles and matrix templates from a source project into
    <strong>{{ data.targetProjectName }}</strong>.
  </p>

  <div class="copy-warning" role="note">
    The current target project must be empty. Existing setup cannot be merged with or replaced.
  </div>

  @if (isLoadingSources) {
    <div class="dialog-state" role="status">Loading source projects...</div>
  } @else if (sourceLoadError) {
    <div class="dialog-error" role="alert">{{ sourceLoadError }}</div>
  } @else if (sources.length === 0) {
    <div class="dialog-state">There are no other projects you can administer.</div>
  } @else {
    <label class="source-select-label" for="signature-setup-copy-source">Source project</label>
    <p-select
      inputId="signature-setup-copy-source"
      class="source-select"
      [options]="sources"
      [(ngModel)]="selectedSourceId"
      optionLabel="name"
      optionValue="id"
      placeholder="Select a source project"
      appendTo="body"
      [disabled]="isCopying"
    ></p-select>
    @if (copyError) {
      <div class="dialog-error" role="alert">{{ copyError }}</div>
    }
  }

  <div class="copy-dialog-actions">
  <button pButton class="copy-dialog-action" type="button" label="Cancel" [outlined]="true" severity="secondary" [disabled]="isCopying" (click)="cancel()"></button>
  <button pButton class="copy-dialog-action copy-dialog-primary-action" type="button" [label]="isCopying ? 'Copying signature setup...' : 'Copy signature setup'" [loading]="isCopying" [disabled]="isLoadingSources || sources.length === 0 || selectedSourceId === null || isCopying" (click)="copy()">
  </button>
  </div>
</div>
